import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const root = css`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const filterButton =
  ({ isFullscreen }: { isFullscreen: boolean }) =>
  (theme: ExactTheme) => {
    return [
      css`
        flex-shrink: 0;
      `,
      isFullscreen
        ? css`
            display: none;

            @media ${theme.deviceV2.greaterThan.laptop} {
              display: flex;
            }
            @media ${theme.deviceV2.greaterThan.laptopL} {
              display: none;
            }
          `
        : css`
            display: none;
          `,
    ];
  };

export const smallFilterButton =
  ({ isFullscreen }: { isFullscreen: boolean }) =>
  (theme: ExactTheme) => {
    return [
      css`
        flex-shrink: 0;
      `,
      isFullscreen
        ? css`
            @media ${theme.deviceV2.greaterThan.laptop} {
              display: none;
            }
          `
        : css`
            @media ${theme.deviceV2.greaterThan.laptopL} {
              display: none;
            }
          `,
    ];
  };
